module.exports = __webpack_public_path__ + "c_static/img/2-3淘宝-收藏店铺.52c7ba3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/电脑端轨迹加权/2-3淘宝-收藏店铺.jpg
// module id = CAIH
// module chunks = 33